import React, { useState, useEffect } from 'react';
import CookieBanner from './CookieBanner';
import CookiePreferencesModal from './CookiePreferencesModal';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { trackCookieConsent } from '@/utils/tracking';
import { CookieConsent } from '@/types/cookies';

const CookieManager: React.FC = () => {
    const {
        consent,
        showBanner,
        loading,
        acceptAll,
        rejectAll,
        updateConsent,
        setShowBanner
    } = useCookieConsent();

    const [showPreferencesModal, setShowPreferencesModal] = useState(false);

    
    useEffect(() => {
        const handleShowPreferences = () => {
            setShowPreferencesModal(true);
        };

        window.addEventListener('show-cookie-preferences', handleShowPreferences);
        return () => {
            window.removeEventListener('show-cookie-preferences', handleShowPreferences);
        };
    }, []);

   
    if (loading) {
        return null;
    }

    const handleAcceptAll = () => {
        acceptAll();
        trackCookieConsent('accept_all');
    };

    const handleRejectAll = () => {
        rejectAll();
        trackCookieConsent('reject_all');
    };

    const handleCustomize = () => {
        setShowPreferencesModal(true);
    };

    const handleCloseBanner = () => {
        setShowBanner(false);
    };

    const handleCloseModal = () => {
        setShowPreferencesModal(false);
    };

    const handleSavePreferences = (newConsent: Omit<CookieConsent, 'timestamp' | 'version'>) => {
        updateConsent(newConsent);
        trackCookieConsent('customize', newConsent);
    };

    return (
        <>
            {showBanner && (
                <CookieBanner
                    onAcceptAll={handleAcceptAll}
                    onRejectAll={handleRejectAll}
                    onCustomize={handleCustomize}
                    onClose={handleCloseBanner}
                />
            )}

            {showPreferencesModal && <CookiePreferencesModal
                isOpen={showPreferencesModal}
                onClose={handleCloseModal}
                onSave={handleSavePreferences}
                currentConsent={consent}
            />}
        </>
    );
};

export default CookieManager;
